import ekmpLogo from "@/assets/ekmp-logo.png";
import ekmpFooterLogo from "@/assets/ekmp-logo-footer.png";

const sizeClasses = {
  header: "h-12 md:h-14",
  footer: "h-14",
};

export default function BrandLogo({ className = "", variant = "header" }) {
  const logo = variant === "footer" ? ekmpFooterLogo : ekmpLogo;

  return (
    <img
      src={logo}
      alt="EKO Markets Procurement"
      className={`${sizeClasses[variant] || sizeClasses.header} w-auto object-contain ${className}`}
    />
  );
}
